import {ChevronRightIcon} from '@primer/octicons-react'
import {IconButton, ProgressBar} from '@primer/react'
import styles from './MiniMergeSections.module.css'
import {useGoToMergeBox} from '../../../mergebox/use-go-to-mergebox'

export function ApprovalsMiniStatus() {
  const goToMergeBox = useGoToMergeBox()

  return (
    <section className={styles.MiniStatus} aria-label="Approvals">
      <div className={styles.MiniStatusLabelRow}>
        {/* TODO: Add a leading icon based on the approvals state. */}
        <strong>Approvals</strong>
        <IconButton
          aria-label="View approvals"
          icon={ChevronRightIcon}
          // TODO: Update the panel to open the approvals section in the merge status panel. The current open panel options
          // don't support expanding sections within the merge status panel
          onClick={event => goToMergeBox(event.currentTarget)}
          size="small"
          variant="invisible"
        />
      </div>
      {/* TODO: Derive progress from required approvals. */}
      <ProgressBar aria-label="Approvals progress" className={styles.MiniStatusProgress} progress={100} />
    </section>
  )
}
